import {
  ClinicUserListingModel,
  IClinicUserListingModel,
  IUserFeatureFlagModel,
  UserFeatureFlagModel,
  HospitalOrganizationRelationListingModel,
  IHospitalOrganizationRelationListingModel,
  IModel,
  Model,
  IOrganizationRelationListingModel,
  OrganizationRelationListingModel,
} from '@common/models';
import {
  AuthOperationModel,
  IAuthOperationModel,
  AuthRoleModel,
  IAuthRoleModel,
} from '@common/models/Security';

export interface IUserModel extends IModel {
  userId: number;
  firstName: string | undefined;
  lastName: string | undefined;
  emailAddress: string | undefined;
  objectIdentifier: string | undefined;
  allowSecurityAdmin: boolean;
  organizationRelationKey: string | undefined;
  implicitAuthRoles: IAuthRoleModel[];
  explicitAuthRoles: IAuthRoleModel[];
  authOperations: IAuthOperationModel[];
  recentClinics: IClinicUserListingModel[];
  organizations: IOrganizationRelationListingModel[];
  userFeatureFlags: IUserFeatureFlagModel[];
  hospitalOrganizations: IHospitalOrganizationRelationListingModel[];
  employeeId: string | undefined;
  employeeType: string | undefined;
  employmentStatusName: string | undefined;
  universalProviderId: string | undefined;
  isProfileActive: boolean;
  optInToAudioRecording: boolean;
}

export class UserModel extends Model implements IUserModel {
  userId: number;
  firstName: string | undefined;
  lastName: string | undefined;
  emailAddress: string | undefined;
  objectIdentifier: string | undefined;
  allowSecurityAdmin: boolean;
  organizationRelationKey: string | undefined;
  implicitAuthRoles: IAuthRoleModel[];
  explicitAuthRoles: IAuthRoleModel[];
  authOperations: IAuthOperationModel[];
  recentClinics: IClinicUserListingModel[];
  organizations: IOrganizationRelationListingModel[];
  userFeatureFlags: IUserFeatureFlagModel[];
  hospitalOrganizations: IHospitalOrganizationRelationListingModel[];
  employeeId: string | undefined;
  employeeType: string | undefined;
  employmentStatusName: string | undefined;
  universalProviderId: string | undefined;
  isProfileActive: boolean;
  optInToAudioRecording: boolean;

  constructor(params: Partial<IUserModel>) {
    super(params);
    const {
      userId = 0,
      firstName = undefined,
      lastName = undefined,
      emailAddress = undefined,
      objectIdentifier = undefined,
      allowSecurityAdmin = false,
      organizationRelationKey = '',
      implicitAuthRoles = [],
      explicitAuthRoles = [],
      authOperations = [],
      recentClinics = [],
      organizations = [],
      userFeatureFlags = [],
      hospitalOrganizations = [],
      employeeId = undefined,
      employeeType = undefined,
      employmentStatusName = undefined,
      universalProviderId = undefined,
      isProfileActive = false,
      optInToAudioRecording = false,
    } = params;

    this.userId = userId;
    this.firstName = firstName;
    this.lastName = lastName;
    this.emailAddress = emailAddress;
    this.objectIdentifier = objectIdentifier;
    this.allowSecurityAdmin = allowSecurityAdmin;
    this.organizationRelationKey = organizationRelationKey;
    this.employeeId = employeeId;
    this.employeeType = employeeType;
    this.employmentStatusName = employmentStatusName;
    this.universalProviderId = universalProviderId;
    this.isProfileActive = isProfileActive;
    this.optInToAudioRecording = optInToAudioRecording;

    this.implicitAuthRoles = new Array<IAuthRoleModel>();
    if (implicitAuthRoles && implicitAuthRoles.length) {
      implicitAuthRoles.forEach((value) => {
        this.implicitAuthRoles.push(new AuthRoleModel(value));
      });
    }

    this.explicitAuthRoles = new Array<IAuthRoleModel>();
    if (explicitAuthRoles && explicitAuthRoles.length) {
      explicitAuthRoles.forEach((value) => {
        this.explicitAuthRoles.push(new AuthRoleModel(value));
      });
    }

    this.organizations = new Array<IOrganizationRelationListingModel>();
    if (organizations && organizations.length) {
      organizations.forEach((value) => {
        this.organizations.push(new OrganizationRelationListingModel(value));
      });
    }

    this.recentClinics = new Array<IClinicUserListingModel>();
    if (recentClinics && recentClinics.length) {
      recentClinics.forEach((value) => {
        this.recentClinics.push(new ClinicUserListingModel(value));
      });
    }

    this.authOperations = new Array<IAuthOperationModel>();
    if (authOperations && authOperations.length) {
      authOperations.forEach((value) => {
        this.authOperations.push(new AuthOperationModel(value));
      });
    }

    this.userFeatureFlags = new Array<IUserFeatureFlagModel>();
    if (userFeatureFlags && userFeatureFlags.length) {
      userFeatureFlags.forEach((value) => {
        this.userFeatureFlags.push(new UserFeatureFlagModel(value));
      });
    }

    this.hospitalOrganizations =
      new Array<IHospitalOrganizationRelationListingModel>();
    if (hospitalOrganizations && hospitalOrganizations.length) {
      hospitalOrganizations.forEach((value) => {
        this.hospitalOrganizations.push(
          new HospitalOrganizationRelationListingModel(value),
        );
      });
    }
  }
}
